import { render, staticRenderFns } from "./ed-scan-document-modal.component.vue?vue&type=template&id=74835884&scoped=true&"
import script from "./ed-scan-document-modal.component.ts?vue&type=script&lang=ts&"
export * from "./ed-scan-document-modal.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-scan-document-modal.component.scss?vue&type=style&index=0&id=74835884&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74835884",
  null
  
)

export default component.exports